export class AppError extends Error {
  statusCode: number;
  isOperational: boolean;
  originalError?: any;

  constructor(message: string, statusCode: number, originalError?: any) {
    super(message);
    this.statusCode = statusCode;
    this.isOperational = true;
    this.originalError = originalError;

    // Maintains proper stack trace in V8
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, this.constructor);
    }

    // Set the prototype explicitly.
    Object.setPrototypeOf(this, AppError.prototype);
  }
}
